import React, { useState,useEffect } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import SelectDate from "../components/popups/SelectDate";
import { ChangeDateStringOnlyDate,ChangeDateFormat,isNull,ToggleDarkBackground } from "../../components/common/Common";

import centerIcon from "../../img/icon/icon-center-class-03.svg";
import "../../css/style.css";

//비밀번호 찾기
const SemesterDetail = () => {
  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const { sm_idx } = useParams();
  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  //학기정보
  const [varSemesterInfo,setSemesterInfo] = useState({});

  //진행 또는 예정학기 내역
  const [varSemesterList,setSemesterList] = useState([]);

  //편집모드 - 학기정보 호출
  const GetSemsterInformation = async() => {
    const sendData = {sm_idx:sm_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_semester_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) setSemesterInfo(datas.results[0]);
      }
    });
  }

  //신규등록모드 - 진행 또는 예정학기 내역 호출
  const GetSemesterStatus = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_semester_status`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) setSemesterList(datas.results);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    const newData = {sm_idx:Number(sm_idx),sm_bh_idx:branch_idx,sm_name:"",sm_sdate:null,sm_edate:null,sm_rdate:null,sm_status:1};
    setSemesterInfo(newData);

    if(Number(sm_idx) === 0) GetSemesterStatus();
    else GetSemsterInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //정보입력부
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    setSemesterInfo({...varSemesterInfo,[name]:value});
  }

  //날짜선택 팝업창
  const [varPopupDaySelect,setPopupDaySelect] = useState(false);  //팝업창 열기/닫기
  const [varDate,setDate] = useState(null); //선택된 날짜
  const [varDateMode,setDateMode] = useState(0);  //날짜 항목
  const [varFromDate,setFromDate] = useState(null);
  const onChangeDateHandler = (e,imode) => {
    setDateMode(imode);
    const sdate = new Date(varSemesterInfo.sm_sdate);
    if(imode === 1) {
      // 이전 일자 비활성화 제거
      // setFromDate(new Date());
      setDate(sdate);
    } else {
      const edate = new Date(varSemesterInfo.sm_edate);
      setFromDate(sdate);
      setDate(edate);
    }
    TogglePopupDaySelect(true);
  }
  const TogglePopupDaySelect = (bmode) => {
    setPopupDaySelect(bmode);
    ToggleDarkBackground(bmode);
  }
  //검색기간 설정값 저장
  const ChangedDate = (ino,date) => {
    if(date === "" ) date = null;
    const ndate = ChangeDateFormat(date);
    if(ino === 1){ 
      setSemesterInfo({...varSemesterInfo,sm_sdate:ndate});
    } else {
      setSemesterInfo({...varSemesterInfo,sm_edate:ndate});
    }
    TogglePopupDaySelect(false);
  }

  //수정모드로 변경
  const onEditSemesterHandler = (e) => {
    const diableBoxes = document.querySelectorAll(".disable-only");
    const showBoxes = document.querySelectorAll(".show-only");
    const hideBox = document.querySelector('.hide-only');
    const buttonNumBox = document.querySelector('.btn-no');
    for(var i1=0; i1 < diableBoxes.length; i1++) {
      diableBoxes[i1].classList.remove('disable-only');
    }
    for(var i2=0; i2 < showBoxes.length; i2++) {
      showBoxes[i2].classList.add('hide-only');
    }
    hideBox.classList.remove('hide-only');
    console.log(buttonNumBox);
    buttonNumBox.setAttribute('style','width:48%');
  }
  
  //삭제
  const onDeleteSemesterHandler = async(e) => {
    const sendData = {sm_idx:sm_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_semester`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/SemesterSet');
      } else {
        alert(datas.message);
      }
    });
  }

  //학기등록
  const onUpdateSemesterHandler = async(e) => {
    if(isNull(varSemesterInfo.sm_name)) {
      alert('학기명을 먼저 입력하세요.'); return false;
    } else if(isNull(varSemesterInfo.sm_sdate)) {
      alert('개강일을 먼저 선택하세요.'); return false;
    } else if(isNull(varSemesterInfo.sm_edate)) {
      alert('종강일을 먼저 선택하세요하세요.'); return false;
    }

    //신규의 경우 - 날짜 점검
    if(Number(sm_idx) === 0) {
      const stdate = new Date(varSemesterInfo.sm_sdate);
      const eddate = new Date(varSemesterInfo.sm_edate);
      for(var i=0; i < varSemesterList.length; i++) {
        let sdate = new Date(varSemesterList[i].sm_sdate);
        let edate = new Date(varSemesterList[i].sm_edate);
        if((sdate.getTime() <= stdate.getTime() && edate.getTime() >= stdate.getTime()) || (sdate.getTime() <= eddate.getTime() && edate.getTime() >= eddate.getTime())) {
          alert('지정된 기간에 이미 등록되어 있는 학기가 존재합니다. 학기 시각/종료일을 재설정하세요.');
          return false;
        }
      }
    }

    if(!window.confirm('지정된 학기의 정보를 저장하시겠습니까?')) return false;
    const sendData = {branch_idx:branch_idx,sm_idx:sm_idx,dataInfo:varSemesterInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_semester`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/SemesterSet');
      } else {
        alert(datas.message);
      }
    });
  }

  return (
    <div className="vh-content" style={{minHeight:"100vh"}}>
      <HeaderBranchTitle varPageTitle={Number(sm_idx)===0?'학기 추가':'학기 설정 상세'} varBackString={'/Branch/SemesterSet'}/>
      <div className="vh-content-body">
        <div className="cl-setting-form-wrap">
          <div className="form-group mb15">
							<label className="form-label">학기명</label>
							<div className="field-group">
								<input type="text" name="sm_name" className={Number(sm_idx)===0?"form-control":"form-control disable-only"} placeholder="학기명을 입력하세요." value={varSemesterInfo.sm_name||""} onChange={e=>onChangeInputHandler(e)}/>
							</div>
						</div>

						<div className="form-group mb15">
							<label className="form-label">개강일</label>
							<div className="field-group flex">
								<div className="has-btn">
									<input type="text" value={ChangeDateStringOnlyDate(varSemesterInfo.sm_sdate)||""} name="sm_sdate" className="input-cal" disabled/>
									<button className={Number(sm_idx)===0?"cal-btn":"cal-btn disable-only"} onClick={e=>onChangeDateHandler(e,1)}><img src={centerIcon} alt=""/></button>
								</div>
							</div>
						</div>
						
						<div className="form-group mb15">
							<label className="form-label">종강일</label>
							<div className="field-group flex">
								<div className="has-btn">
									<input type="text" value={ChangeDateStringOnlyDate(varSemesterInfo.sm_edate)||""} name="sm_edate" className="input-cal" disabled/>
									<button className={Number(sm_idx)===0?"cal-btn":"cal-btn disable-only"} onClick={e=>onChangeDateHandler(e,2)}><img src={centerIcon} alt=""/></button>
								</div>								
							</div>
						</div>
						
						<div className="class-date" style={Number(sm_idx)===0?{display:"none"}:{}}>
							<div>등록일 : {ChangeDateStringOnlyDate(varSemesterInfo.sm_rdate)||""}</div>
						</div>

						<div className="form-contoller bt-btn">
              <Link to={'/Branch/SemesterSet'} className="form-contoller-btn btn-no" style={Number(sm_idx)===0?{width:"48%"}:{}}>취소</Link>
              <button className={Number(sm_idx)===0?"form-contoller-btn btn-yes hide-only":"form-contoller-btn btn-yes show-only"} onClick={e=>onEditSemesterHandler(e)}>수정</button>
              <button className={Number(sm_idx)===0?"form-contoller-btn btn-del hide-only":"form-contoller-btn btn-yes show-only"} onClick={e=>onDeleteSemesterHandler(e)}>삭제</button>
							<button className={Number(sm_idx)===0?"form-contoller-btn btn-yes":"form-contoller-btn btn-yes hide-only"} onClick={e=>onUpdateSemesterHandler(e)} style={{marginRight:"0"}}>확인</button>
						</div>
        </div>
      </div>
      <SelectDate varDate={varDate} setDate={setDate} varDateMode={varDateMode} varFromDate={varFromDate}
              varPopupDaySelect={varPopupDaySelect} TogglePopupDaySelect={TogglePopupDaySelect} 
              ChangedDate={ChangedDate}/>
    </div>	
  );
}
export default SemesterDetail;